module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cookieData.show),
      expression: "cookieData.show"
    }],
    staticClass: "w-imbee-cookieBanner",
    class: {
      'w-imbee-cookieBanner--rejected': this.rejectedView,
      'w-imbee-cookieBanner--configuration': this.configurationView
    },
    style: (_vm.cssVars)
  }, [_c('div', {
    staticClass: "w-imbee-cookieBanner__banner"
  }, [_c('div', {
    staticClass: "w-imbee-cookieBanner__banner__text",
    domProps: {
      "innerHTML": _vm._s(_vm.cookieData.text)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-imbee-cookieBanner__buttons"
  }, [_c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowStrict",
    on: {
      "click": _vm.handleConfigure
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.configureText) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowAll",
    on: {
      "click": _vm.handleAllowAll
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.allowAllText) + "\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.configurationView),
      expression: "this.configurationView"
    }],
    staticClass: "w-imbee-cookieBanner__configuration"
  }, [_c('div', {
    staticClass: "w-imbee-cookieBanner__configuration__text",
    domProps: {
      "innerHTML": _vm._s(_vm.cookieData.configurationText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-imbee-cookieBanner__buttons"
  }, [_c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button",
    on: {
      "click": _vm.handleRejectAll
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.rejectAllText) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button",
    on: {
      "click": _vm.handleAllowStrict
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.allowStrictText) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--cancelReject",
    on: {
      "click": _vm.handleCancelConfigure
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.cancelText) + "\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.rejectedView),
      expression: "this.rejectedView"
    }],
    staticClass: "w-imbee-cookieBanner__rejected"
  }, [_c('div', {
    staticClass: "w-imbee-cookieBanner__rejected__text",
    domProps: {
      "innerHTML": _vm._s(_vm.cookieData.rejectedText)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "w-imbee-cookieBanner__buttons"
  }, [_c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowStrict",
    on: {
      "click": _vm.handleConfigure
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.configureText) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "w-imbee-cookieBanner__buttons__button w-imbee-cookieBanner__buttons__button--allowAll",
    on: {
      "click": _vm.handleAllowAll
    }
  }, [_vm._v("\n                " + _vm._s(_vm.cookieData.allowAllText) + "\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-789b748c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CookieBanner.vue
// module id = 217
// module chunks = 0 1